import { type onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsConnectionSlice';
import { DetailsEventsWrapper } from 'app/main/components/page-layouts';

const sendSaveNotification: onAfterSaveType = ({ intl, isAdd, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (
			modifiedModel.skll_user_assigned_uid &&
			modifiedModel.skll_user_assigned_uid !== model.skll_user_modified_uid
		) {
			sendNotification({
				message: {
					createdBy: modifiedModel.skll_user_modified_uid,
					assignedTo: modifiedModel.skll_user_assigned_uid,
					title: 'Nuova Competenza assegnata',
					body: `${model.user_modified_title} ti ha assegnato a "${model.skll_title}".`,
					url: `${window.location.origin}/skills/details/${model.skll_uid}`,
					icon: 'book',
					variant: 'info'
				}
			});
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params =>
	DetailsEventsWrapper(params.modifiedModel)([sendSaveNotification(params)]);

export default { onAfterSave };
